import { render, staticRenderFns } from "./cost-details.vue?vue&type=template&id=1d233fb3"
import script from "./cost-details.vue?vue&type=script&lang=js"
export * from "./cost-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports